/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { EncryptionService } from '../../services/encryption.service';
import { resolveAgentLandingPath } from '../constants/keys.constant';

@Injectable({
  providedIn: 'root',
})
export class premissionServices {
  constructor(
    private router: Router,
    private _authService: AuthService,
    private _encryptionService: EncryptionService
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this._authService.isAuthenticated()) {
      const profile = this._encryptionService.decryptLocalStorage('profile');
      const defaultRoute = resolveAgentLandingPath('/dashboard', profile?.type);
      this.router.navigate([defaultRoute]);
      return false;
    } else {
      return true;
    }
  }
}
export const MainGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  return inject(premissionServices).canActivate(next, state);
};
